// ==================================================================================================
//  TECH DEBT: THIS CODE WAS TAKEN FROM https://github.com/tombolaltd/javascript-arcade
//             AND SHOULD BE REPLACED WITH A SUITABLE NPM PACKAGE ONCE AVAILABLE
// ==================================================================================================
import { Sprite, Texture } from 'pixi.js';

class SliderControl extends Sprite {
  private enabledTexture: Texture;
  private disabledTexture: Texture;
  private enabled: boolean;
  private changeSlideCallback: (index: number) => void;
  private transitionSlideInCallback: () => void;
  public controlIndex: number;

  constructor(textures: {enabled: Texture, disabled: Texture},
              enabled: boolean,
              changeSlideCallback: (index: number) => void,
              transitionSlideInCallback: () => void,
              controlIndex: number) {
    super(enabled ? textures.enabled : textures.disabled);

    this.enabledTexture = textures.enabled;
    this.disabledTexture = textures.disabled;
    this.enabled = enabled;
    this.changeSlideCallback = changeSlideCallback;
    this.transitionSlideInCallback = transitionSlideInCallback;
    this.controlIndex = controlIndex;

    this.interactive = true;
    this.on('pointerup', this.onPointerUp);
  }

  private onPointerUp() {
    if (this.enabled) { return; }
    this.enable();
    this.changeSlideCallback(this.controlIndex);
    this.transitionSlideInCallback();
  }

  public handleOrientationChange(controlAreaHeight: number, controlIndex: number) {
    this.width = this.height = controlAreaHeight * 0.8;

    this.position.x = (this.width * 1.2) * this.controlIndex;
  }

  public enable(): void {
    this.texture = this.enabledTexture;
    this.enabled = true;
  }

  public disable() {
    this.texture = this.disabledTexture;
    this.enabled = false;
  }
}

export { SliderControl };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/arcade-game/_components/how-to-play/_domain/slider/slider-control.ts